export const routeHistory = {
  history: [],

  push(route) {
    if (route.name) {
      this.history.push(route);
      if (this.history.length > 5) this.history.shift();
    }
  },

  get(n = 1) {
    return this.history[this.history.length - n] || null;
  },
};
